import i18n from 'sharedKernel/i18n/translate/config'
import { camelCaseToScreamingSnakeCase, normalizeComparableString } from 'sharedKernel/utils'
import type { ScoutingCriterionDefinition } from '../api/scoutingService'
import { isScoutingSelectionFieldId, SCOUTING_CRITERION_NAME_KEYS } from './constants'
import type { ScoutingSelectionFieldId } from './types'

const criterionNameMatchesField = (apiName: string, fieldId: ScoutingSelectionFieldId): boolean => {
  const key = SCOUTING_CRITERION_NAME_KEYS[fieldId]
  const n = normalizeComparableString(apiName)
  return n === normalizeComparableString(String(i18n.t(key)))
}

const definitionMatchesSelectionField = (def: ScoutingCriterionDefinition, fieldId: string): boolean => {
  const code = (def.code || '').trim().toUpperCase()
  if (code === camelCaseToScreamingSnakeCase(fieldId) || code === fieldId.toUpperCase()) return true
  if (!isScoutingSelectionFieldId(fieldId)) return false
  return criterionNameMatchesField(def.name || '', fieldId)
}

export const findScoutingCriterionDefinitionId = (
  definitions: ScoutingCriterionDefinition[] | undefined,
  fieldId: string
): string | undefined => definitions?.find((d) => definitionMatchesSelectionField(d, fieldId))?.id
